 /**
  * @Author: Zewei
  * @Date:   2018-01-29T10:00:02+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-24T14:13:07+08:00
  */

 import keyMirror from "keymirror";

 export const DailyReport = {
   ActionTypes: keyMirror({
     // common
     FETCHDATA: null,
     FETCHSUCCESS: null,
     FETCHFAILURE: null,
     CREATESUCCESS: null,
     CREATEFAILURE: null,
     UPDATESUCCESS: null,
     UPDATEFAILURE: null,
     DELETESUCCESS: null,
     DELETEFAILURE: null,

     // daily report
     INITDAILYREPORTSUCCESS: null,
     EDITDAILYREPORTSUCCESS: null,
     FETCHDAILYREPORTSUCCESS: null,
     FETCHLEADERDAILYREPORTSUCCESS: null,
     // other report
     FETCHUSERGROUPSUCCESS: null,
     FETCHUSERGROUPFAILURE: null,
     CREATEUSERGROUPSUCCESS: null,
     CREATEUSERGROUPFAILURE: null,
     FETCHREPORTSUCCESS: null,
     FETCHREPORTFAILURE: null,
     FETCHREPORTINITSUCCESS: null,
     FETCHREPORTINITFAILURE: null,
     CREATEREPORTESUCCESS: null,
     CREATEREPORTEFAILURE: null,
     DELETEUSERGROUPSUCCESS: null,
     DELETEUSERGROUPEFAILURE: null,
     FETCHEUSERGROUPDETAILSUCCESS: null,
     FETCHEUSERGROUPDETAILFAILURE: null,
     FETCHCURRENTUSERDETAILSUCCESS: null,
     FETCHCURRENTUSERDETAILFAILURE: null,
     FETCHREPORTDETAILSUCCESS: null,
     FETCHREPORTDETAILFAILURE: null,
     DELETEREPORTSSUCCESS: null,
     DELETEREPORTSFAILURE: null,
     UPDATEUSERGROUPSUCCESS: null,
     UPDATEUSERGROUPFAILURE: null,
     EMPTYUSERGROUPDETAIL: null,
     //userGroupDetail修改特殊查看人
     FETCHUSERGROUPDETAILLISTSUCCESS:null,
     UPDATEUSERGROUPDETAILLISTSUCCESS:null,
     EMPTY: null,
   })
 };



// WEBPACK FOOTER //
// ./src/constants/daily-report-constants.js